// extracted by mini-css-extract-plugin
export var actionButton = "_wp-2";
export var card = "_wp-0";
export var disambiguationList = "_wp-3";
export var errorCard = "_wp-4";
export var row = "_wp-1";